var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSec1Icon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sec1Icon1",
    transform: "translate(-480 -280)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4837",
    "data-name": "\\uC0AC\\uAC01\\uD615 4837",
    width: 50,
    height: 50,
    rx: 12,
    transform: "translate(480 280)",
    fill: "#eaf0f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "free-icon-pencil-588395",
    transform: "translate(492 292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33569",
    "data-name": "\\uD328\\uC2A4 33569",
    d: "M3.475,352.5.02,359.655a.189.189,0,0,0,.252.253l7.156-3.456.708-.708-3.953-3.953Z",
    transform: "translate(0 -333.927)",
    fill: "#fed9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33570",
    "data-name": "\\uD328\\uC2A4 33570",
    d: "M.272,436.04l3.791-1.831L1.85,432,.02,435.788A.189.189,0,0,0,.272,436.04Z",
    transform: "translate(0 -410.06)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33571",
    "data-name": "\\uD328\\uC2A4 33571",
    d: "M1.105,396.813a.186.186,0,0,0,.216.037l7.156-3.456.708-.708L7.208,390.71Z",
    transform: "translate(-1.049 -370.869)",
    fill: "#f4c892"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33572",
    "data-name": "\\uD328\\uC2A4 33572",
    d: "M1.105,456.682a.186.186,0,0,0,.216.037l3.791-1.831-1.106-1.106Z",
    transform: "translate(-1.049 -430.738)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33573",
    "data-name": "\\uD328\\uC2A4 33573",
    d: "M90.406.818h0a2.8,2.8,0,0,1,0,3.953L72.667,22.51l-3.953-3.953L86.453.818A2.8,2.8,0,0,1,90.406.818Z",
    transform: "translate(-65.225 0)",
    fill: "#ffbf14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33574",
    "data-name": "\\uD328\\uC2A4 33574",
    d: "M133.417,4.065h0a2.783,2.783,0,0,0-1.007-.645,2.8,2.8,0,0,1-.645,2.946L114.026,24.105l1.652,1.652L133.417,8.018A2.8,2.8,0,0,0,133.417,4.065Z",
    transform: "translate(-108.236 -3.246)",
    fill: "#ff901d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4884",
    "data-name": "\\uC0AC\\uAC01\\uD615 4884",
    width: 5.59,
    height: 2.128,
    transform: "translate(19.699 2.348) rotate(45)",
    fill: "#21d8de"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4885",
    "data-name": "\\uC0AC\\uAC01\\uD615 4885",
    width: 2.365,
    height: 2.128,
    transform: "translate(21.98 4.628) rotate(45)",
    fill: "#11b9c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33575",
    "data-name": "\\uD328\\uC2A4 33575",
    d: "M393.4.818h0a2.8,2.8,0,0,0-3.953,0l-1.529,1.529L391.875,6.3,393.4,4.771A2.8,2.8,0,0,0,393.4.818Z",
    transform: "translate(-368.223 0)",
    fill: "#ff4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33576",
    "data-name": "\\uD328\\uC2A4 33576",
    d: "M436.191,4h0a2.783,2.783,0,0,0-1.016-.648,2.8,2.8,0,0,1-.648,2.937L433,7.822l1.664,1.664,1.529-1.529A2.8,2.8,0,0,0,436.191,4Z",
    transform: "translate(-411.01 -3.185)",
    fill: "#f33939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4886",
    "data-name": "\\uC0AC\\uAC01\\uD615 4886",
    width: 1.866,
    height: 20.796,
    transform: "translate(6.126 21.194) rotate(-135)",
    fill: "#ffb123"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec1Icon1);
export default __webpack_public_path__ + "static/media/sec1Icon1.f7e9b8b0dbad6dcfdf60ec94267c4ed0.svg";
export { ForwardRef as ReactComponent };